import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import administration from "@/features/administration/i18n/fr.json";
import auth from "@/features/auth/i18n/fr.json";
import logiciels from "@/features/logiciels/i18n/fr.json";
import parametrage from "@/features/parametrage/i18n/fr.json";
import planning from "@/features/planning/i18n/fr.json";

import common from "./locales/fr/common.json";

const resources = {
  fr: {
    common,
    auth,
    logiciels,
    administration,
    parametrage,
    planning,
  },
} as const;

void i18next.use(initReactI18next).init({
  resources,
  lng: "fr",
  fallbackLng: "fr",
  supportedLngs: ["fr"],
  ns: Object.keys(resources.fr),
  defaultNS: "common",
  returnEmptyString: false,
  showSupportNotice: false,
  initAsync: false,
  interpolation: { escapeValue: false },
});
